/* ============================================================
   Modulo: Marquee — seamless scrolling-text engine.

   Mirrors the announcement-bar / logo-cloud engine:
   - Measure one cycle = width of the original items + their gaps.
   - Clone the set until the track ≥ viewport + 1 cycle, so off-screen
     content is always queued → no gap, no jump on loop, with any
     number/length of items.
   - Set --modulo-mq-cycle-width so CSS translates by exact pixels and
     lands on a clean boundary every loop.
   - Mark ready=1 so the CSS animation attaches (no jumpy first paint).
   - Under prefers-reduced-motion we don't clone or animate; CSS wraps +
     centers the originals instead.
   Each `[data-modulo-mq]` row inits independently (duo = two rows).
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getGap(el) {
    var style = getComputedStyle(el);
    var n = parseFloat(style.columnGap || style.gap || '0');
    return isNaN(n) ? 0 : n;
  }

  function measureCycle(items, gap) {
    var w = 0;
    for (var i = 0; i < items.length; i++) {
      w += items[i].getBoundingClientRect().width;
    }
    // One gap per item so the loop boundary stays aligned between repeats.
    return w + gap * items.length;
  }

  function cloneSet(track, items) {
    for (var i = 0; i < items.length; i++) {
      var clone = items[i].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      track.appendChild(clone);
    }
  }

  function init(row) {
    if (REDUCE) return;
    var track = row.querySelector('.modulo-marquee__track');
    if (!track || track.dataset.moduloMqReady === '1') return;

    var items = Array.prototype.slice.call(track.children);
    if (items.length === 0) return;

    var gap = getGap(track);
    var cycle = measureCycle(items, gap);
    if (cycle <= 0) return; // layout not ready

    var viewport = row.offsetWidth || document.documentElement.clientWidth;
    var copiesNeeded = Math.max(2, Math.ceil((viewport + cycle) / cycle));
    for (var c = 0; c < copiesNeeded; c++) cloneSet(track, items);

    track.style.setProperty('--modulo-mq-cycle-width', cycle + 'px');
    track.dataset.moduloMqReady = '1';
  }

  function boot() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-mq]', init);
    } else {
      var rows = document.querySelectorAll('[data-modulo-mq]');
      for (var i = 0; i < rows.length; i++) init(rows[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-fill on resize (only ever ADD clones — cheap and safe).
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (REDUCE) return;
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var rows = document.querySelectorAll('[data-modulo-mq]');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var track = row.querySelector('.modulo-marquee__track');
        if (!track || track.dataset.moduloMqReady !== '1') continue;
        var needed = row.offsetWidth * 2;
        var safety = 0;
        while (track.scrollWidth < needed && safety < 4) {
          var snapshot = Array.prototype.slice.call(track.children);
          for (var j = 0; j < snapshot.length; j++) {
            var clone = snapshot[j].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('role');
            track.appendChild(clone);
          }
          safety++;
        }
      }
    }, 200);
  });
})();
